import { useMutation, useQueryClient } from "react-query";
import { updateStandard } from "../../../../../actions/Utilities/Standard";
import { toast } from "../../../../../components/toastNotification";
import { StandardInfo } from "../type/StandardInterface";

const useUpdateStandard = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (newData: StandardInfo) => updateStandard(newData),
    {
      onSuccess: (res: any) => {
        if (res.data === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetStandard"]);
          toast.fire("Success", "Standard Updated Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Update Standard!", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateStandard;
